// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type EventInvitedGroupsQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type EventInvitedGroupsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { invitedGroups: Array<(
        { __typename?: 'GroupModelGQLBase' }
        & InvitedGroupFragment
      )> }
    )> }
  )> }
);

export type RecurringEventInvitedGroupsQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RecurringEventInvitedGroupsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { invitedGroups: Array<(
        { __typename?: 'GroupModelGQLBase' }
        & InvitedGroupFragment
      )> }
    )> }
  )> }
);

export type InvitedGroupFragment = (
  { __typename?: 'GroupModelGQLBase' }
  & Pick<PrivateSchemaTypes.GroupModelGqlBase, 'id' | 'name' | 'usersCount'>
);

export type RemoveGroupInviteMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveGroupInviteMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'removeGroupInvite'>
    )> }
  )> }
);

export type RemoveGroupFromSeriesInviteMutationVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RemoveGroupFromSeriesInviteMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'removeGroupInvite'>
    )> }
  )> }
);

export const InvitedGroupFragmentDoc = gql`
    fragment invitedGroup on GroupModelGQLBase {
  id
  name
  usersCount
}
    `;
export const EventInvitedGroupsDocument = gql`
    query eventInvitedGroups($eventId: PositiveInt!) {
  admin {
    event(id: $eventId) {
      id
      invitedGroups {
        ...invitedGroup
      }
    }
  }
}
    ${InvitedGroupFragmentDoc}`;

/**
 * __useEventInvitedGroupsQuery__
 *
 * To run a query within a React component, call `useEventInvitedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInvitedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInvitedGroupsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventInvitedGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EventInvitedGroupsQuery, EventInvitedGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EventInvitedGroupsQuery, EventInvitedGroupsQueryVariables>(EventInvitedGroupsDocument, options);
      }
export function useEventInvitedGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventInvitedGroupsQuery, EventInvitedGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EventInvitedGroupsQuery, EventInvitedGroupsQueryVariables>(EventInvitedGroupsDocument, options);
        }
export type EventInvitedGroupsQueryHookResult = ReturnType<typeof useEventInvitedGroupsQuery>;
export type EventInvitedGroupsLazyQueryHookResult = ReturnType<typeof useEventInvitedGroupsLazyQuery>;
export type EventInvitedGroupsQueryResult = Apollo.QueryResult<EventInvitedGroupsQuery, EventInvitedGroupsQueryVariables>;
export const RecurringEventInvitedGroupsDocument = gql`
    query recurringEventInvitedGroups($eventId: PositiveInt!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      invitedGroups {
        ...invitedGroup
      }
    }
  }
}
    ${InvitedGroupFragmentDoc}`;

/**
 * __useRecurringEventInvitedGroupsQuery__
 *
 * To run a query within a React component, call `useRecurringEventInvitedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringEventInvitedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringEventInvitedGroupsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRecurringEventInvitedGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecurringEventInvitedGroupsQuery, RecurringEventInvitedGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecurringEventInvitedGroupsQuery, RecurringEventInvitedGroupsQueryVariables>(RecurringEventInvitedGroupsDocument, options);
      }
export function useRecurringEventInvitedGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecurringEventInvitedGroupsQuery, RecurringEventInvitedGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecurringEventInvitedGroupsQuery, RecurringEventInvitedGroupsQueryVariables>(RecurringEventInvitedGroupsDocument, options);
        }
export type RecurringEventInvitedGroupsQueryHookResult = ReturnType<typeof useRecurringEventInvitedGroupsQuery>;
export type RecurringEventInvitedGroupsLazyQueryHookResult = ReturnType<typeof useRecurringEventInvitedGroupsLazyQuery>;
export type RecurringEventInvitedGroupsQueryResult = Apollo.QueryResult<RecurringEventInvitedGroupsQuery, RecurringEventInvitedGroupsQueryVariables>;
export const RemoveGroupInviteDocument = gql`
    mutation removeGroupInvite($eventId: PositiveInt!, $groupId: PositiveInt!) {
  admin {
    event(id: $eventId) {
      id
      removeGroupInvite(groupId: $groupId)
    }
  }
}
    `;
export type RemoveGroupInviteMutationFn = Apollo.MutationFunction<RemoveGroupInviteMutation, RemoveGroupInviteMutationVariables>;

/**
 * __useRemoveGroupInviteMutation__
 *
 * To run a mutation, you first call `useRemoveGroupInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupInviteMutation, { data, loading, error }] = useRemoveGroupInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useRemoveGroupInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveGroupInviteMutation, RemoveGroupInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveGroupInviteMutation, RemoveGroupInviteMutationVariables>(RemoveGroupInviteDocument, options);
      }
export type RemoveGroupInviteMutationHookResult = ReturnType<typeof useRemoveGroupInviteMutation>;
export type RemoveGroupInviteMutationResult = Apollo.MutationResult<RemoveGroupInviteMutation>;
export type RemoveGroupInviteMutationOptions = Apollo.BaseMutationOptions<RemoveGroupInviteMutation, RemoveGroupInviteMutationVariables>;
export const RemoveGroupFromSeriesInviteDocument = gql`
    mutation removeGroupFromSeriesInvite($eventId: PositiveInt!, $groupId: PositiveInt!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      removeGroupInvite(groupId: $groupId)
    }
  }
}
    `;
export type RemoveGroupFromSeriesInviteMutationFn = Apollo.MutationFunction<RemoveGroupFromSeriesInviteMutation, RemoveGroupFromSeriesInviteMutationVariables>;

/**
 * __useRemoveGroupFromSeriesInviteMutation__
 *
 * To run a mutation, you first call `useRemoveGroupFromSeriesInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupFromSeriesInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupFromSeriesInviteMutation, { data, loading, error }] = useRemoveGroupFromSeriesInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useRemoveGroupFromSeriesInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveGroupFromSeriesInviteMutation, RemoveGroupFromSeriesInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveGroupFromSeriesInviteMutation, RemoveGroupFromSeriesInviteMutationVariables>(RemoveGroupFromSeriesInviteDocument, options);
      }
export type RemoveGroupFromSeriesInviteMutationHookResult = ReturnType<typeof useRemoveGroupFromSeriesInviteMutation>;
export type RemoveGroupFromSeriesInviteMutationResult = Apollo.MutationResult<RemoveGroupFromSeriesInviteMutation>;
export type RemoveGroupFromSeriesInviteMutationOptions = Apollo.BaseMutationOptions<RemoveGroupFromSeriesInviteMutation, RemoveGroupFromSeriesInviteMutationVariables>;